// export const apiLink =
//   "https://placement-portal16.herokuapp.com/docs";
// export const apiLink = "https://placement-portal16.herokuapp.com/";

export const apiLink = "https://jyvvccokn3.execute-api.us-east-1.amazonaws.com/";